import { CREATE_BEWERTUNG } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useCreateBewertung/mutation';
import { Mitarbeiter_CreateRotationsplanBewertungMutationVariables } from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

export function useCreateBewertung() {
  const [execute, result] = useMutation(CREATE_BEWERTUNG, {
    refetchQueries: ['mitarbeiter_rotationsplanById'],
    awaitRefetchQueries: true,
  });

  const createBewertung = useCallback(
    (variables: Mitarbeiter_CreateRotationsplanBewertungMutationVariables) => {
      return execute({
        variables,
      });
    },
    [execute],
  );

  return [createBewertung, result] as const;
}
